import { Component, NgIterable } from '@angular/core';
import { FieldType, FieldTypeConfig, FormlyModule } from '@ngx-formly/core';


@Component({
    selector: 'app-multicheckbox',
    templateUrl: './multicheckbox.component.html',
    imports: [FormlyModule]
})
export class MulticheckboxComponent extends FieldType<FieldTypeConfig> {
  defaultOptions = {
    props: { options: [] }
  };

  get multicheckboxOptions(): NgIterable<any> {
    return this.props.options as NgIterable<any>;
  }

  onChange(value: any, target: EventTarget) {
    const checked = (target as HTMLInputElement).checked;
    if (this.props.type === 'array') {
      this.formControl.patchValue(checked ? [...(this.formControl.value || []), value] : [...(this.formControl.value || [])].filter(o => o !== value));
    } else {
      this.formControl.patchValue({ ...this.formControl.value, [value]: checked });
    }
    this.formControl.markAsTouched();
  }
}
